var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Model from 'models/Model';
import { Role } from 'models';
import { plainToInstance } from 'class-transformer';
var JobTitle = /** @class */ (function (_super) {
    __extends(JobTitle, _super);
    function JobTitle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    JobTitle.prototype.getId = function () {
        return Number(this.id);
    };
    JobTitle.prototype.getTitle = function () {
        return this.title;
    };
    JobTitle.prototype.setTitle = function (title) {
        this.title = title;
    };
    JobTitle.prototype.getBaseSalary = function () {
        return Number(this.base_salary);
    };
    JobTitle.prototype.setBaseSalary = function (baseSalary) {
        this.base_salary = Number(baseSalary);
    };
    JobTitle.prototype.getRoleId = function () {
        return Number(this.role_id);
    };
    JobTitle.prototype.getEmployeesCount = function () {
        return Number(this.employees_count) || 0;
    };
    JobTitle.prototype.setRoleId = function (roleId) {
        this.role_id = Number(roleId);
    };
    JobTitle.prototype.getRole = function () {
        return plainToInstance(Role, this.role);
    };
    return JobTitle;
}(Model));
export default JobTitle;
